import { Separator, Button } from '@/ui'

export const TaxProfileFormFooter = ({
  goToPreviousStep,
  submitOrContinue,
  continueDisabled,
  loading,
  nextText = 'Continue',
}: {
  goToPreviousStep: () => void
  submitOrContinue: () => void
  continueDisabled?: boolean
  loading?: boolean
  nextText?: string
}) => (
  <>
    <Separator className="my-4" />
    <div className="flex flex-col sm:flex-row w-full items-center justify-between gap-4">
      <div className="sm:w-1/2 w-full">
        <Button onClick={goToPreviousStep} variant="secondary">
          Back
        </Button>
      </div>

      <div className="sm:w-1/2 w-full flex justify-end">
        <Button
          onClick={submitOrContinue}
          disabled={continueDisabled}
          loading={loading}
        >
          {nextText}
        </Button>
      </div>
    </div>
  </>
)
